<lib-loading-shimmer [showLoading]="loading()" class="icon-cell">
  <mat-icon [svgIcon]="iconName()" (click)="handleClick(); $event.stopPropagation()" [class]="iconName()" [libTooltip]="iconToolTip() ?? ''"></mat-icon>
</lib-loading-shimmer>
